import { Grid, Stack } from "@mui/material";
import React from "react";

const GeneralDetails = () => {
  return (
    <Grid container spacing={1} className="w-full p-10 my-4">
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Code
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        12345
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Name
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Gokulnath
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Designation
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Software Developer
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Joining Date
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        12345
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Status
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Active
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Company
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Nolt FZE
      </Grid>

      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Email
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        gokulnath.r@giglabz.com
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        DOB
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        12/34/05
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Address
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Dubai
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Department
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        IT CONSULTANT
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Pay Group
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Office
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Religion
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        12345
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Location
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderTop: "2px whitesmoke solid", padding: "8px !important" }}
      >
        Dubai
      </Grid>
    </Grid>
    // <table className="w-full">
    //   <tr
    //     style={{
    //       borderTop: "2px whitesmoke solid", padding:"8px !important",
    //       borderBottom: "2px whitesmoke solid", padding:"8px !important",
    //       display: "flex",
    //       justifyContent: "space-between",
    //     }}
    //   >
    //     <td>Code</td>
    //     <td>123</td>
    //   </tr>
    // </table>
  );
};

export default GeneralDetails;
